// extracted by mini-css-extract-plugin
module.exports = {"container":"blogCard_container__1jqGU","image":"blogCard_image__penkQ","content":"blogCard_content__32-ZZ","date":"blogCard_date__2jYTO","title":"blogCard_title__2Z-58","text":"blogCard_text__324Lp"};
    if(module.hot) {
      // 1745935575308
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  